<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      桥头站<br>
站点介绍<br>
桥头站位于宝安大道与桥和路交叉口北侧，沿宝安大道路中南北向布置。该站为本线的高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:20	23:52	11号线	4分钟	6分32秒<br>
碧头	06:31	00:15	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:20	23:52	11号线	4分34秒	6分钟<br>
碧头	06:31	00:15	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:20	23:52	11号线	4分37秒	6分钟<br>
碧头	06:31	00:15	11号线	4分37秒	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
宝安大道西侧、福源工业区<br><br>
B出入口:<br>
宝安大道西侧、桥和路、汉光大楼、桥头村、同泰时代中心、同泰时代广场<br><br>
C出入口:<br>
宝安大道东侧、福永水厂<br><br>
D出入口:<br>
宝安大道东侧、万丰村<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 坪山城市候机楼<br>
M220、 M294、M295、M325、M326、M439、M447、M480、M546、高峰专线8、高峰专线64<br><br>
牛角龙居民小组：M368C1出入口:<br>
公交站名： 深业东城上邸<br>
941、E22、M220、 M294、M295、M325、366、M326、M439、M546、高峰专线8、高峰专线64<br><br>
D出入口:<br>
公交站名： 坪山城市候机楼<br>
366、833、941、A5、 B678、E17、E20、M220、 M294、M295、M325、M326、M439、M447、M368、M480、高峰专线8、高峰专线64<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>